import React from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';
import Button from 'components/common/Button';

const propTypes = {
  logout: PropTypes.func.isRequired,
  abandoned: PropTypes.bool,
};

const continueApplication = () => (window.location = `/${COUNTRY.toLowerCase()}/apply${location.search}`);

const CreditApplicationIncomplete = ({ logout, abandoned }) => (
  <div className="container">
    <div className="content-block txt-center credit-application-status">
      <div className="credit-application-status__icon">
        <span className="icon icon--error" />
      </div>
      <h3 className="txt-error">
        <FormattedMessage id={`selfservice.application.${abandoned ? 'abandoned' : 'open'}.header`} />
      </h3>
      <FormattedMessage id={`selfservice.application.${abandoned ? 'abandoned' : 'open'}.info`} tagName="p" />
      <br />
      <div className="grid">
        <div className="grid__item two-fifths palm-one-whole">
          <Button
            type="button"
            isFullWidth
            onClick={continueApplication}
            btnType={abandoned ? 'secondary' : null}
          >
            <FormattedMessage id={`selfservice.application.${abandoned ? 'abandoned' : 'open'}.button.continue`} />
          </Button>
          {abandoned && (
            <div className="credit-application-status__logout">
              <button className="link" onClick={logout} type="button">
                <FormattedMessage id="logout.send" />
              </button>
            </div>
          )}
          {!abandoned && (
            <Button
              type="button"
              isFullWidth
              onClick={logout}
              btnType="secondary"
            >
              <FormattedMessage id="logout.send" />
            </Button>
          )}
        </div>
      </div>
    </div>
  </div>
);

CreditApplicationIncomplete.propTypes = propTypes;

export default CreditApplicationIncomplete;
